import { render, staticRenderFns } from "./JsonPage.vue?vue&type=template&id=63371266&scoped=true"
import script from "./JsonPage.vue?vue&type=script&lang=js"
export * from "./JsonPage.vue?vue&type=script&lang=js"
import style0 from "./JsonPage.vue?vue&type=style&index=0&id=63371266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63371266",
  null
  
)

export default component.exports